import * as React from "react";
import { useGetAllBusinessVerticalsQuery } from "../services/vertical.service";
import SelectBase, { SelectOption } from "./global/SelectBase";

const SelectVertical = ({
  onChange,
  value,
}: {
  onChange: (arg?: number) => void;
  value: number;
}) => {
  const {
    data: verticals,
    isLoading,
  } = useGetAllBusinessVerticalsQuery({
    sortField: "name",
    sortMode: "asc",
  });

  const options = React.useMemo<SelectOption[]>(() => {
    return (verticals || []).map((vertical) => ({
      label: vertical.name,
      value: vertical.id,
    }));
  }, [verticals]);

  const selected = React.useMemo<SelectOption | null>(() => {
    if (!value || !verticals) return null;
    const vertical = verticals.find((it) => it.id == value);
    return vertical ? { label: vertical.name, value: vertical.id } : null;
  }, [verticals, value]);

  return (
    <SelectBase
      options={options}
      value={selected}
      onChange={(newValue) => {
        const option = newValue as SelectOption | null;
        onChange(option?.value as number | undefined);
      }}
      label="Industry"
      placeholder="Search..."
      isLoading={isLoading}
    />
  );
};
export default SelectVertical;
